<template>
  <div>
    <div class="">
      <div class="text-h5">Certificate Configuration Generator</div>
      <hr />

      <div class="q-pa-md" style="max-width: 400px">
      <q-form
          @submit="onSubmit"
          class="q-gutter-md"
      >
          <q-input
          filled
          type="number"
          v-model="courseId"
          label="Course ID *"
          lazy-rules
          :rules="[
              val => val !== null && val !== '' && val > 0 || 'Please insert the Course ID'
          ]"
          />

          <q-input
          filled
          type="number"
          v-model="quizId"
          label="Quiz ID *"
          lazy-rules
          :rules="[
              val => val !== null && val !== '' && val > 0 || 'Please insert the Quiz ID'
          ]"
          />

          <q-input
          filled
          type="number"
          v-model="minScore"
          label="Minimum Score Required *"
          lazy-rules
          :rules="[
              val => val !== null && val !== '' && val > 0 || 'Please add a score requirement'
          ]"
          />

          <div>
            <q-btn label="Generate" type="submit" color="primary" class="q-mr-md" />
            <q-spinner v-if="isLoading"
              color="primary"
              size="3em"
            />
          </div>
      </q-form>
      </div>
    </div>
    <div v-if="error" class="row">
      <div class="col-12">
        <div class="text-red">
          {{ error }}
        </div>
      </div>
    </div>
    <div v-if="configUrl" class="row">
      <div class="col-12">
        <div class="text-subtitle2">

          <q-input
          type="text"
          v-model="configUrl"
          label="XML Configuration URL"
          dense
          readonly
          >
            <template v-slot:after>
              <q-btn round dense flat color="primary" icon="content_copy" @click="copyUrl" />
            </template>
          </q-input>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'
import { useQuasar } from 'quasar'
import axios from 'axios'

export default {
  name: 'config-generator',

  setup () {
    const courseId = ref(null)
    const quizId = ref(null)
    const minScore = ref(null)
    const configUrl = ref(null)
    const error = ref('')
    const isLoading = ref(false)
    const $q = useQuasar()

    const onSubmit = async () => {
      isLoading.value = true
      error.value = null
      configUrl.value = null

      try {
        const res = await axios.get(`/api/generateUrl?courseId=${courseId.value}&quizId=${quizId.value}&scoreReq=${minScore.value}`)
        configUrl.value = res.data.configUrl
      } catch (err) {
        if (err && err.response && err.response.data) {
          error.value = err.response.data
        } else {
          error.value = err
        }
      }

      isLoading.value = false
    }

    const copyUrl = () => {
      navigator.clipboard.writeText(configUrl.value)
      $q.notify({ type: 'positive', message: 'Copied to clipboard!', position: 'bottom-left' })
    }

    return {
      courseId,
      quizId,
      minScore,
      configUrl,
      error,
      isLoading,
      onSubmit,
      copyUrl
    }
  }
}
</script>
